import axiosInstance from "./api"; // Ensure path is correct to your axios config

const messageApi = {
  // Get all messages between two users
  getMessages: (senderId, receiverId) =>
    axiosInstance.get(
      `/messages?senderId=${senderId}&receiverId=${receiverId}`,
    ),

  // Get list of all conversations for a user
  getConversations: (userId) =>
    axiosInstance.get(`/messages/conversations/${userId}`),

  // Mark messages from a specific sender as read
  markAsRead: (senderId, receiverId) =>
    axiosInstance.post("/messages/mark-read", {
      senderId,
      receiverId,
    }),

  // Send a new message via API (Optional, as we use Socket for real-time)
  sendMessage: (data) => axiosInstance.post("/messages/send", data),
};

export default messageApi;
